import { useState } from 'react';
import { RiskAction } from '../../models';
import { apiClient, apiErrorMessage } from '../../utils';
import { Button, Form, Input } from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import { InboxOutlined } from '@ant-design/icons';

export function RiskActionSolutionForm(props: { riskAction?: RiskAction; onSaved?: () => void }) {
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<any[]>();

  const dummyUploadRequest = ({ onSuccess }: any) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    setUploadedFiles(e.fileList.map((f: any) => f.originFileObj));
    return e && e.fileList;
  };

  const onFinish = (values: any) => {
    var formData = new FormData();

    if (uploadedFiles?.length) {
      for (let i = 0; i < uploadedFiles?.length; i++) {
        formData.append(`files[${i}]`, uploadedFiles[i]);
      }
    }

    for (let key of Object.keys(values)) {
      if (key !== 'dragger' && values[key]) {
        formData.append(key, values[key]);
      }
    }

    setLoading(true);
    apiClient
      .patch(`risk-actions/${props.riskAction?.id}/solution`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        if (props.onSaved) {
          props.onSaved();
        }
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish}>
      <Form.Item
        label="Çözüm açıklaması"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="solutionMessage"
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item label="Dokümanlar" required>
        <Form.Item
          name="dragger"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          noStyle
          rules={[{ required: true, message: 'Çözüm önerisi için en az bir doküman eklenmelidir.' }]}
        >
          <Dragger name="files" multiple={true} customRequest={dummyUploadRequest}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Bir dosya sürükleyin veya tıklayın</p>
          </Dragger>
        </Form.Item>
      </Form.Item>

      <Form.Item style={{ marginTop: '2rem', textAlign: 'center' }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Gönder
        </Button>
      </Form.Item>
    </Form>
  );
}
